import { render, staticRenderFns } from "./repairForm.vue?vue&type=template&id=21078508"
import script from "./repairForm.vue?vue&type=script&lang=js"
export * from "./repairForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports